module.exports = __webpack_public_path__ + "static/media/modelvid.1ca5cc16.png";